import React from "react";
import { useBotStore } from "../../stores/botStore";
import CancellationArchiveTable from "./CancellationArchiveTable";
import CancellationQueueTable from "./CancellationQueueTable";
import { formatDate } from "utils/format";

// Компонент відображення вкладки "Очікування"
const CancellationQueueTab = () => {
  // Отримуємо дані менеджера зі стору
  const managers = useBotStore((state) => state.managers);

  // Налаштування відображення статусу в обох таблицях
  const getStatusBadge = (status) => {
    const statusNames = {
      pending: "Очікує",
      processed: "Оброблено",
      failed: "Помилка",
    };
    return (
      <span className={`status-badge status-${status}`}>
        {statusNames[status] || status}
      </span>
    );
  };

  // Налаштування відображення типу в обох таблицях
  const getTypeBadge = (type) => {
    const typeNames = { clean: "Видалення", change: "Зміна" };
    return <span className={`type-badge type-${type}`}>{typeNames[type] || type}</span>;
  };

  // Функція для отримання імені менеджера по його ID
  const getManagerName = (managerId) => {
    const manager = managers.find((m) => String(m.manager_id) === String(managerId));
    return manager ? manager.manager_name : `ID: ${managerId}`;
  };

  return (
    <div className="queue-tab">
      <div className="botsettings-container">
        <div className="botsettings-content">
          <CancellationQueueTable
            managers={managers}
            getManagerName={getManagerName}
            getStatusBadge={getStatusBadge}
            getTypeBadge={getTypeBadge}
            formatDate={formatDate}
          />
        </div>
      </div>
      <div className="botsettings-container">
        <div className="botsettings-content">
          <CancellationArchiveTable
            getManagerName={getManagerName}
            getStatusBadge={getStatusBadge}
            formatDate={formatDate}
          />
        </div>
      </div>
    </div>
  );
};

export default CancellationQueueTab;
